import React from 'react';
import PropTypes from 'prop-types';
import { FilledButton } from '@ds/react-components';

import * as Styled from './ConfirmationModal.styled';

const ConfirmationModal = (props) => {
  const { isOpen, onCancelAccountClick, onCloseClick, displayText } = props;

  return (
    <Styled.ConfirmDialog
      open={isOpen}
      disableBackdropClick
      fullWidth
      disableEscapeKeyDown>
      <Styled.DialogContentContainer>
        <Styled.DangerIcon />
        <Styled.Title>{'Confirmation'}</Styled.Title>
        <Styled.ContentTextContainer>
          {displayText.map((text) => (
            <Styled.ContentText key={text}>{text} </Styled.ContentText>
          ))}
        </Styled.ContentTextContainer>
        <Styled.ActionButtonContainer>
          <FilledButton variant="error" onClick={onCancelAccountClick}>
            {'Confirm'}
          </FilledButton>
          <Styled.NoButton variant={'slighter'} onClick={onCloseClick}>
            {'Cancel'}
          </Styled.NoButton>
        </Styled.ActionButtonContainer>
      </Styled.DialogContentContainer>
    </Styled.ConfirmDialog>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancelAccountClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  displayText: PropTypes.arrayOf(PropTypes.string),
};

ConfirmationModal.defaultProps = {
  displayText: [],
};

export default ConfirmationModal;
